import { IKeHoachMonSelectByNhomLopRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectByNhomLopRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

// reload: bộ lọc lưới Kế hoạch môn nhóm lớp — saga dispatch LOAD_NHOMLOP_FULL_START sau khi tạo xong
export const eXepTkbChuanBiActionsObj = {
    TAO_LAI_THEO_MON_START: {} as { ids: number[], ky_dang_ky: number, reload: IKeHoachMonSelectByNhomLopRequest },
    TAO_LAI_THEO_MON_SUCCESS: undefined,
    TAO_LAI_THEO_MON_ERROR: "",

    CAP_NHAT_SU_KIEN_START: {} as { ids: number[], ky_dang_ky: number, reload: IKeHoachMonSelectByNhomLopRequest },
    CAP_NHAT_SU_KIEN_SUCCESS: undefined,
    CAP_NHAT_SU_KIEN_ERROR: "",
};
export const eXepTkbChuanBiActionIds = generateActionTypeIds(
    eXepTkbChuanBiActionsObj,
    "XEP_TKB_CHUAN_BI"
);
export type IXepTkbChuanBiActionTypes = IGenericActionType<
    typeof eXepTkbChuanBiActionsObj,
    "XEP_TKB_CHUAN_BI"
>;
